"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeActivationStatus = exports.sendActivationEmail = exports.activateUser = exports.activateUserWithKey = exports.validateUserKey = exports.validatePasswordKey = exports.resetPassword = exports.resendValidationEmail = exports.requestPasswordReset = exports.getUserByParticipantId = exports.getUserByUserId = exports.updateUser = exports.updateParticipant = exports.createUser = exports.updateMe = exports.getMe = void 0;
var network_1 = require("../network");
var utils_1 = require("../utils");
function getMe() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, network_1.simpleGet({
                    path: "/users/me",
                })];
        });
    });
}
exports.getMe = getMe;
function updateMe(_a) {
    var me = _a.me;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simplePut({
                    path: "/users/me",
                    body: me,
                })];
        });
    });
}
exports.updateMe = updateMe;
function createUser(_a) {
    var user = _a.user;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simplePost({
                    path: "/users/participants",
                    body: user,
                })];
        });
    });
}
exports.createUser = createUser;
function updateParticipant(_a) {
    var user = _a.user;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simplePut({
                    path: "/users/participants",
                    body: user,
                })];
        });
    });
}
exports.updateParticipant = updateParticipant;
function updateUser(_a) {
    var user = _a.user;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simplePut({
                    path: "/users",
                    body: user,
                })];
        });
    });
}
exports.updateUser = updateUser;
function getUserByUserId(_a) {
    var userId = _a.userId;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simpleGet({
                    path: "/users/" + userId,
                })];
        });
    });
}
exports.getUserByUserId = getUserByUserId;
function getUserByParticipantId(_a) {
    var participantId = _a.participantId;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simpleGet({
                    path: "/users/participants/" + participantId,
                })];
        });
    });
}
exports.getUserByParticipantId = getUserByParticipantId;
function requestPasswordReset(_a) {
    var email = _a.email;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.postForEmpty({
                    path: "/users/password-reset",
                    body: email,
                })];
        });
    });
}
exports.requestPasswordReset = requestPasswordReset;
function resendValidationEmail(_a) {
    var email = _a.email;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simplePost({
                    path: "/users/resend-validation-email",
                    body: email,
                })];
        });
    });
}
exports.resendValidationEmail = resendValidationEmail;
function resetPassword(_a) {
    var vm = _a.vm;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.postForEmpty({
                    path: "/users/password-reset/new-password",
                    body: vm,
                })];
        });
    });
}
exports.resetPassword = resetPassword;
function validatePasswordKey(params) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, network_1.getJson({
                    path: "/users/password-reset/validate" + utils_1.buildQueryParams(params),
                }).then(function (r) { return r.json; })];
        });
    });
}
exports.validatePasswordKey = validatePasswordKey;
function validateUserKey(params) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, network_1.getJson({
                    path: "/users/validate" + utils_1.buildQueryParams(params),
                }).then(function (r) { return r.json; })];
        });
    });
}
exports.validateUserKey = validateUserKey;
function activateUserWithKey(params) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, network_1.getForEmpty({
                    path: "/users/activate" + utils_1.buildQueryParams(params),
                })];
        });
    });
}
exports.activateUserWithKey = activateUserWithKey;
function activateUser(_a) {
    var credentials = _a.credentials;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.postForJson({
                    path: "/users/activate",
                    body: credentials,
                }).then(function (r) { return r.json; })];
        });
    });
}
exports.activateUser = activateUser;
function sendActivationEmail(_a) {
    var email = _a.email;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simpleGet({
                    path: "/users/sendActivationEmail/" + encodeURIComponent(email),
                })];
        });
    });
}
exports.sendActivationEmail = sendActivationEmail;
function changeActivationStatus(_a) {
    var vm = _a.vm;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.postAuthForEmpty({
                    path: "/users/activation-status",
                    body: vm,
                })];
        });
    });
}
exports.changeActivationStatus = changeActivationStatus;
//# sourceMappingURL=userResource.js.map